function handleCompositionItemClick(event, blockId) {
  const buttons = document.querySelectorAll('.composition-item-button');
  const testimonials = document.querySelectorAll('.composition-item__testimonial-container');
  const images = document.querySelectorAll('.composition-item__image-container');
  buttons.forEach((button) => {
    button.classList.remove('active');
  });

  testimonials.forEach((testimonial) => {
    testimonial.classList.remove('active');
  });

  images.forEach((image) => {
    image.classList.remove('active');
  });

  const clickedButton = event.currentTarget;
  clickedButton.classList.add('active');

  const activeContent = document.querySelectorAll(`[data-composition-item="${blockId}"]`);
  if (activeContent) {
    activeContent.forEach((content) => {
      content.classList.add('active');
    });
  }
}